import { render, staticRenderFns } from "./ModalActivity.vue?vue&type=template&id=197ed785&scoped=true&"
import script from "./ModalActivity.vue?vue&type=script&lang=js&"
export * from "./ModalActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ed785",
  null
  
)

export default component.exports